import * as React from 'react';

import AccessibleSVG from '../accessible-svg';
import { TwoTonedIcon } from '../iconTypes';

const IconPowerPointOnline = ({ className = '', height = 30, title, width = 30 }: TwoTonedIcon) => (
    <AccessibleSVG
        className={`icon-powerpoint-online ${className}`}
        height={height}
        title={title}
        viewBox="0 0 30 30"
        width={width}
    >
        <path
            d="M14 24.47a.48.48 0 0 1-.5-.46V3.74a.49.49 0 0 1 .5-.49h14.45a.49.49 0 0 1 .48.49V24a.5.5 0 0 1-.48.48H14"
            fill="#fff"
        />
        <path
            d="M14 2.77a1 1 0 0 0-1 1V24a1 1 0 0 0 1 1h14.45a1 1 0 0 0 1-1V3.74a1 1 0 0 0-1-1zm0 1h14.45V24H14z"
            fill="#b84729"
        />
        <path d="M20.13 6.61v3.76h3.75a3.77 3.77 0 0 0-3.75-3.76z" fill="#b84729" />
        <path d="M18.87 7.87a3.76 3.76 0 1 0 3.76 3.76h-3.76z" fill="#b84729" />
        <path d="M16.76 0L0 3v21.89l16.76 2.95V0" fill="#b84729" />
        <path d="M12.61 16.63h13.78v1.25H12.61zM12.61 19.13h13.78v1.26H12.61z" fill="#b84729" />
        <path
            d="M8.07 9.44l-2.6.17v9.7l1.64.11V16h.81a3.75 3.75 0 0 0 .67 0 4.24 4.24 0 0 0 .61-.17 2.9 2.9 0 0 0 .54-.31 2.4 2.4 0 0 0 .47-.43 3.68 3.68 0 0 0 .37-.51 3.11 3.11 0 0 0 .26-.59 3.15 3.15 0 0 0 .16-.69 4.52 4.52 0 0 0 .06-.74 4.68 4.68 0 0 0-.2-1.44 2.63 2.63 0 0 0-.57-1 2.19 2.19 0 0 0-.94-.55 3.25 3.25 0 0 0-1.28-.12m-1 4.87v-3.1h.66a1.74 1.74 0 0 1 .6.08 1 1 0 0 1 .44.27 1.25 1.25 0 0 1 .26.48 2.59 2.59 0 0 1 .09.68 2.82 2.82 0 0 1-.09.71 1.41 1.41 0 0 1-.26.5 1.12 1.12 0 0 1-.44.3 1.55 1.55 0 0 1-.6.1h-.62m12.47 2.92A6.49 6.49 0 0 0 13 23.12a3.81 3.81 0 0 0-2.08 5c.59 1.44.74 1.91 3.55 1.91H25c2.67.09 4.91-1.56 5-4.23a4.85 4.85 0 0 0-4.43-5 6.78 6.78 0 0 0-6-3.53"
            fill="#fff"
        />
        <path
            d="M14.11 23.7a3.27 3.27 0 0 0 1.27 6.3h9a4.23 4.23 0 0 0 4.4-3.91 4.15 4.15 0 0 0-3.88-4.4 5.82 5.82 0 0 0-5.17-3c-5.15 0-5.62 5.01-5.62 5.01z"
            fill="#b84729"
        />
        <path
            d="M19.7 20.27a4.24 4.24 0 0 1 3.92 2.6l.17.44h.59a2.55 2.55 0 1 1 .32 5.09h-9.32a1.66 1.66 0 0 1-.23-3.3l.58-.08v-.69a4 4 0 0 1 3.94-4.06z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default IconPowerPointOnline;
